import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

const PageBody = (props:any) => {
    const classes = props.className;
    const classesBody = props.classNameBody;
    return (
        <Row>
            <Col>
                <Card className={classes}>
                    <CardBody className={classesBody}>
                        {props.children}
                    </CardBody>
                </Card> 
            </Col>
        </Row>
    )
}

export default PageBody;